<template>
    <div>
        <div class="weui-panel">
            <div class="weui-panel__bd">
                <div class="weui-media-box weui-media-box_appmsg">
                    <div class="weui-media-box__hd">
                        <img class="weui-media-box__thumb" :src="cover" style="border-radius:5px;">
                    </div>
                    <div class="weui-media-box__bd">
                        <h4 class="weui-media-box__title">{{title}}</h4>
                        <p class="weui-media-box__desc">{{excerpt}}</p>
                        <div class="weui-media-box__info">
                            <a href="javascript:void(0);" class="weui-media-box__info__meta" @click="showPicker()">
                                <svg class="icon"><use xlink:href="#th-list" /></svg>&nbsp;选集
                            </a>
                            <router-link :to="sortRoute" class="weui-media-box__info__meta">
                                排序
                                <svg class="icon" v-if="sort"><use xlink:href="#sort-alpha-down" /></svg>
                                <svg class="icon" v-else><use xlink:href="#sort-alpha-up" /></svg>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="weui-panel__ft">
                <router-link :to="summaryRoute" class="weui-cell weui-cell_access weui-cell_link">
                    <div class="weui-cell__bd">简介</div>
                    <span class="weui-cell__ft"></span>
                </router-link>
            </div>
        </div>

        <weui-picker
            :visible.sync="pickerShow"
            :columns="pickerData"
            value-key="label"
            @confirm="confirmPicker"
            />

        <div class="weui-panel weui-panel_access">
            <div class="weui-panel__bd">
                <a class="weui-media-box weui-media-box_appmsg"
                    v-for="item in items" :key="item.num" 
                    :href="item.url" >
                    <div class="weui-media-box__bd">
                        <h4 class="weui-media-box__title">{{item.title}}</h4>
                        <p class="weui-media-box__desc">{{item.excerpt}}</p>
                    </div>
                </a>
            </div>
        </div>

        <div class="weui-btn-area weui-flex">
            <div>    
                <router-link class="weui-btn weui-btn_mini weui-btn_primary"
                    :to="prevRoute"
                    v-if="prevPage != 0">&laquo; 上一页</router-link>
                <div class="weui-btn weui-btn_mini weui-btn_primary weui-btn_disabled" v-else>&laquo; 上一页</div>
            </div>
            <div class="weui-flex__item">
            </div>
            <div>    
                <router-link class="weui-btn weui-btn_mini weui-btn_primary"
                :to="nextRoute"
                v-if="nextPage != 0">下一页 &raquo;</router-link>
                <div class="weui-btn weui-btn_mini weui-btn_primary weui-btn_disabled" v-else>下一页 &raquo;</div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/svg/th-list.svg"
import "@/assets/svg/sort-alpha-down.svg"
import "@/assets/svg/sort-alpha-up.svg"
import WeuiPicker from "@/components/weui/Picker"

export default {
    name: "TextEdition",
    data: function() {
        return {
            title: "",
            excerpt: "",
            cover: "",
            items: [],
            prevPage: 0,
            nextPage: 0,
            sortPage: 0,
            page: 1,
            sort: 0,

            pickerShow: false,
            pickerData: [
                {
                    values: []
                }
            ],
        };
    },
    created () {
        // 组件创建完后获取数据，
        // 此时 data 已经被 observed 了
        this.fetchData()
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'fetchData'
    },
    computed: {
        prevRoute: function() {
            return this.getRoute(this.prevPage, this.sort);
        },
        nextRoute: function() {
            return this.getRoute(this.nextPage, this.sort);
        },
        sortRoute: function() {
            return this.getRoute(this.sortPage, this.sort == 1 ? 0 : 1);
        },
        summaryRoute() {
            return `/service/${this.$route.params.sid}`;
        }
    },
    methods: {
        fetchData: function() {
            var id = this.$route.params.id;
            if (id != undefined) {
                var a = id.split("-");
                this.page = a[0];
                this.sort = a[1];
            } else {
                this.page = 1;
                this.sort = 0;
            }

            this.$store.commit('loading');
            this.$axios.get(`service/${this.$route.params.sid}/text`, {
                params: {
                    page: this.page,
                    sort: this.sort
                }
            }).then(response => {
                this.title = response.data.title;
                this.excerpt = response.data.excerpt;
                this.cover = response.data.cover;
                this.items = response.data.items;
                this.prevPage = response.data.prevPage != undefined ? response.data.prevPage : 0;
                this.nextPage = response.data.nextPage != undefined ? response.data.nextPage : 0;
                this.sortPage = response.data.sortPage != undefined ? response.data.sortPage : 0;
                this.pickerData[0].values = response.data.pickerData;

                this.$store.commit('loading', false);
            });
        },
        getRoute: function(page, sort) {
            return {
                path: `/service/${this.$route.params.sid}/text/${page}-${sort}`
            }        
        },
        showPicker: function() {
            this.pickerShow = true;
        },
        confirmPicker: function(picker) {
            var page = picker.getValues()[0].value;
            this.$router.push(this.getRoute(page, this.sort));
        }
    },
    components: {
        WeuiPicker
    }
};
</script>

<style scoped>
.icon {
    width: 10px;
    height: 10px;
}
</style>
